// extracted by mini-css-extract-plugin
export default {"componentWrapper":"GridSwitcher_componentWrapper__4DSeY","gridIcon":"GridSwitcher_gridIcon__y+uTN","active":"GridSwitcher_active__gSK6F","name":"GridSwitcher_name__JYGrV"};